import { Directive, Output, EventEmitter } from '@angular/core';
import { EventHandler, EventBusService } from '../../event-bus';

@Directive({ selector: 'lum-df-form' })
export class MainEventsDirective extends EventHandler {
  @Output() onBlur = new EventEmitter<any>();
  @Output() onClear = new EventEmitter<any>();
}
